// extracted by mini-css-extract-plugin
module.exports = {"modal":"Deployments_modal__3wrdk","modal-card":"Deployments_modal-card__2I_N_","modal-title":"Deployments_modal-title__2N1ye","modal-header":"Deployments_modal-header__1xop0"};